module.exports = __webpack_public_path__ + "static/zakiyah-5829c1f9254a13b63ae112d64c414151.jpg";